import { render, staticRenderFns } from "./Contatos.vue?vue&type=template&id=b9a1488e&scoped=true&"
import script from "./Contatos.vue?vue&type=script&lang=js&"
export * from "./Contatos.vue?vue&type=script&lang=js&"
import style0 from "./Contatos.vue?vue&type=style&index=0&id=b9a1488e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a1488e",
  null
  
)

export default component.exports